import React from 'react';

export default React.createContext({ isPc: false });
